<template>
  <div class="preview-two-container">
    <div class="p-content-container" :style="{ backgroundColor: logoBackgroundColor }">
      <img src="@shared/assets/img/promo/preview-two.png" class="p-shell-img" alt="Preview" />
      <div class="p-header-container">
        <div v-if="partnerSettings.LOGO_URL" class="bp-logo-container">
          <img
            v-if="partnerSettings.LOGO_URL"
            class="bp-logo"
            :src="partnerSettings.LOGO_URL"
            alt="Logo"
          />
        </div>
        <div v-else class="bp-logo-container">
          <span class="bp-company-name">{{
            currentCorporation?.displayName || currentCorporation?.corporationName
          }}</span>
        </div>
      </div>
      <div class="p-body-container">
        <div
          v-if="(!imagePreviewOne || imagePreviewOne || imagePreviewTwo) && previewLabelsVisible"
          class="p-image-container"
          :style="{
            backgroundImage: imagePreviewTwo
              ? `url(${imagePreviewTwo})`
              : imagePreviewOne
                ? `url(${imagePreviewOne})`
                : `url(${defaultImg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }"
        >
          <div class="p-image-overlay" />
          <div class="p-text-container">
            <div class="promo-name">
              {{ promo.title || 'Promo Name' }}
            </div>
            <div class="promo-offer-description">
              {{ promo.subTitle || 'Promo description' }}
            </div>
          </div>
        </div>
        <img
          v-else-if="!previewLabelsVisible"
          :src="imagePreviewTwo"
          class="all-over-preview"
          alt="Preview"
        />
        <div :class="['more-details', imagePreviewTwo ? 'smaller' : null]">
          {{ promo.description || 'More details will be shown here.' }}
        </div>
        <div class="button-text-container">
          <div class="button-text">
            {{ promo.actionText || 'CTA' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import promoMixin from '@shared/mixins/promoMixin';

export default {
  name: 'PreviewTwo',
  mixins: [promoMixin],
  props: {
    promo: Object,
    partnerSettings: Object,
    currentCorporation: Object,
    imagePreviewOne: String,
    previewLabelsVisible: Boolean,
    imagePreviewTwo: String,
  },
  computed: {
    logoBackgroundColor() {
      if (!this.partnerSettings.PRIMARY_COLOR || this.partnerSettings.PRIMARY_COLOR === '#FFFFFF') {
        return '#121830';
      }
      return this.partnerSettings.PRIMARY_COLOR;
    },
    defaultImg() {
      return require('@shared/assets/img/promo/default-img.png');
    },
  },
};
</script>
<style lang="scss">
.preview-two-container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 320px;
  height: 600px;

  .p-content-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .p-shell-img {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
    }

    .p-header-container {
      display: flex;
      justify-content: center;
      padding-top: 24px;

      .bp-logo-container {
        height: 70px;
        width: 70px;
        display: flex;
        align-items: center;
        justify-content: center;

        .bp-logo {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .bp-company-name {
          font-size: 1rem;
          color: $N10;
          font-weight: 600;
          text-wrap: nowrap;
        }
      }
    }

    .p-body-container {
      flex: 1;
      z-index: 2;
      display: flex;
      flex-direction: column;

      .p-image-container {
        height: 160px;
        width: 100%;
        background-color: $N100;
        position: relative;
        .p-image-overlay {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background-color: $N100;
          opacity: 0.5;
        }
        .p-text-container {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 0 32px;
          .promo-name {
            color: $WHITE;
            font-size: 1.25rem;
            font-weight: 500;
            text-align: center;
          }

          .promo-offer-description {
            color: $WHITE;
            font-size: 0.875rem;
            font-weight: 500;
            width: 100%;
            text-align: center;
          }
        }
      }

      .more-details {
        padding: 10px 24px;
        font-size: 12px;
        font-weight: 500;
        max-height: 275px;
        overflow-y: auto;
        white-space: pre-wrap;
        word-wrap: break-word;
        &.smaller {
          max-height: 240px;
        }
      }

      .all-over-preview {
        height: 160px;
        object-fit: cover;
        width: 100%;
      }

      .button-text-container {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 20px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;

        .button-text {
          color: $WHITE;
          font-size: 0.875em;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
